import createModule from "../createModule"
import { Creators as notificationsCreators } from "modules/notifications/model"
import view from "./view"
import { getSwapDetails, getFiles, getUploadConfig, getScanResult, getUploadOption, getUploadDateTime, getUploadedFiles } from "./selectors"
import { getSteps } from "./selectors/steps"
import { getActiveStepFromParams } from "helpers/upload-steps"
import { Creators } from "./model"
import withUrlParams from "hocs/withUrlParams"
import withNavigate from "hocs/withNavigate"
import { MODELS_QUERY, getModels } from "resources/models"

export default withUrlParams(withNavigate(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    ticker: props.params.ticker,
  }),
  required: ["account", "ticker"],
  data: [{
    resource: "portfolios",
    as: null,
    url: ({ account }) => `/api/${account}/portfolios`,
  }, {
    resource: "swap",
    as: null,
    url: ({ ticker }) => ({
      id: `swap-${ticker}`,
      query: `query ($ticker: String!) {
        swap (ticker: $ticker) {
          ticker
          description
          availableFrom
          terminationDate
          currencyOverride
        }
      }`,
      variables: {
        ticker,
      },
    }),
  }, {
    ...MODELS_QUERY,
    as: null,
  }],
  mapStateToProps: (state, props) => ({
    files: getFiles(state),
    swapDetails: getSwapDetails(state),
    activeStep: getActiveStepFromParams(props.params),
    steps: getSteps(state),
    uploadConfig: getUploadConfig(),
    scanResult: getScanResult(state),
    uploadOption: getUploadOption(state),
    uploadDateTime: getUploadDateTime(state),
    uploadedFiles: getUploadedFiles(state),
    models: getModels(state),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
  },
})))
